<template>
    <div>
        <base-alert type="danger" class="mb-4" v-if="loaded && danger">
            <i class="fas fa-exclamation-triangle mr-3"></i> {{ $t('pwa.home-notice-danger') }}
            <a href="#" @click.prevent="openOfflineDashboard">{{ $t('pwa.dashboard') }}</a>.
        </base-alert>
    </div>
</template>

<script>
    export default {

        props: {
            autoload: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                loadedCount: 0,
                danger: false,
            }
        },

        created() {
            if (this.autoload) {
                this.refresh()
            }
        },

        computed: {
            loaded() {
                return this.loadedCount == 2
            }
        },

        watch: {
            loaded(val) {
                if (val && this.danger) {
                    this.$emit("show")
                }
            }
        },

        methods: {

            refresh() {
                this.loadedCount = 0
                this.danger = false
                this.loadIndex('/socrates/api/front/offline/logs')
                this.loadIndex('/socrates/api/front/offline/sessions')
            },

            loadIndex(endpoint) {
                axios.get(endpoint).then(resp => {
                    this.checkColors(resp.data.data)
                    this.loadedCount++
                }).catch(error => {
                    this.loadedCount++
                })
            },

            checkColors(items) {
                items.forEach(item => {
                    if (item.sync.color == 'danger') {
                        this.danger = true
                    }
                })
            },

            openOfflineDashboard() {
                this.$router.push({ name: 'offline-dashboard' });
            }
        }
    }
</script>

<style scoped>

    a {
        color: #fff;
        text-decoration: underline;
    }

</style>